import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-light py-3 mt-5">
      <div className="container text-center">
        <a href="/privacy-policy" className="text-muted" >Privacy Policy</a>
      </div>
    </footer>
  );
};

export default Footer;